var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalanceDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 106,
    viewBox: "0 0 188 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177.299,
    height: 65.7522,
    transform: "matrix(1 -6.74015e-08 -1.13391e-07 -1 4.3877 95.1704)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 161.178,
    height: 10.9208,
    transform: "matrix(1 -7.81901e-08 -9.77457e-08 -1 13.953 101.982)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.82142,
    height: 10.9208,
    transform: "matrix(1 -6.74015e-08 -1.13391e-07 -1 10.959 100.92)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.82142,
    height: 10.9208,
    transform: "matrix(1 -6.74015e-08 -1.13391e-07 -1 8.71619 97.5229)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7.82142,
    height: 14.1179,
    transform: "matrix(1 -8.71334e-08 -8.77131e-08 -1 6.74866 41.8447)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7.82142,
    height: 18.7712,
    transform: "matrix(1 -8.71334e-08 -8.77131e-08 -1 32.9553 24.8491)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.82142,
    height: 18.7712,
    transform: "matrix(1 -8.71334e-08 -8.77131e-08 -1 38.1978 29.1636)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.82142,
    height: 18.7712,
    transform: "matrix(1 -8.71334e-08 -8.77131e-08 -1 42.7229 37.1128)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 6.74223,
    height: 10.9208,
    transform: "matrix(1 -7.81901e-08 -9.77457e-08 -1 172.719 97.583)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 6.74223,
    height: 14.1179,
    transform: "matrix(1 -1.0108e-07 -7.56106e-08 -1 171.213 38.9038)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 162.137,
    height: 14.1179,
    transform: "matrix(1 -1.0108e-07 -7.56106e-08 -1 11.9181 36.1587)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3162 22.5503L30.9878 22.5503L30.9878 5.21551L35.3162 5.21551L35.3162 22.5503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6447 5.21582L35.3163 5.21582L35.3163 0.901732L39.6447 0.901732L39.6447 5.21582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0517 9.60791L39.7233 9.60791L39.7233 5.29382L44.0517 5.29382L44.0517 9.60791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3802 13.9219L44.0518 13.9219L44.0518 9.60779L48.3802 9.60779L48.3802 13.9219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7085 18.2363L48.3801 18.2363L48.3801 13.9222L52.7085 13.9222L52.7085 18.2363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1158 22.5503L52.7874 22.5503L52.7874 18.2362L57.1158 18.2362L57.1158 22.5503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.624 22.5508L46.5499 22.5508L46.5499 18.2367L173.624 18.2367L173.624 22.5508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3163 22.5503L15.4843 22.5503L15.4843 18.2362L35.3163 18.2362L35.3163 22.5503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.624 105.117L15.1127 105.117L15.1127 100.803L173.624 100.803L173.624 105.117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.059 92.4771L182.731 92.4771L182.731 31.4436L187.059 31.4436L187.059 92.4771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.324 100.99L173.995 100.99L173.995 96.6757L178.324 96.6757L178.324 100.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.652 96.5977L178.324 96.5977L178.324 92.2836L182.652 92.2836L182.652 96.5977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.324 27.1299L173.995 27.1299L173.995 22.8158L178.324 22.8158L178.324 27.1299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.652 31.4438L178.324 31.4438L178.324 27.1298L182.652 27.1298L182.652 31.4438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7487 92.2905L2.42029 92.2905L2.42028 31.2571L6.74869 31.2571L6.7487 92.2905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4842 100.803L11.1558 100.803L11.1558 96.4886L15.4842 96.4886L15.4842 100.803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0771 96.4102L6.74866 96.4102L6.74866 92.0961L11.0771 92.0961L11.0771 96.4102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4842 26.9429L11.1558 26.9429L11.1558 22.6288L15.4842 22.6288L15.4842 26.9429Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0771 31.2568L6.74866 31.2568L6.74866 26.9427L11.0771 26.9427L11.0771 31.2568Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9552 23.3345L28.6268 23.3345L28.6268 5.99969L32.9552 5.99969L32.9552 23.3345Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2837 5.99951L32.9553 5.99951L32.9553 1.68542L37.2837 1.68542L37.2837 5.99951Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6908 10.3926L37.3624 10.3926L37.3624 6.07849L41.6908 6.07849L41.6908 10.3926Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0192 14.7065L41.6908 14.7065L41.6908 10.3925L46.0192 10.3925L46.0192 14.7065Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3476 19.0205L46.0192 19.0205L46.0192 14.7064L50.3476 14.7064L50.3476 19.0205Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7548 23.3345L50.4264 23.3345L50.4264 19.0204L54.7548 19.0204L54.7548 23.3345Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.634 23.3349L44.5601 23.335L44.5601 19.0209L171.634 19.0209L171.634 23.3349Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9553 23.3345L13.1233 23.3345L13.1233 19.0204L32.9553 19.0204L32.9553 23.3345Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171.634 105.901L13.1233 105.901L13.1233 101.587L171.634 101.587L171.634 105.901Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.698 93.0674L180.37 93.0674L180.37 32.0339L184.698 32.0339L184.698 93.0674Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.963 101.774L171.634 101.774L171.634 97.4603L175.963 97.4603L175.963 101.774Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.291 97.3818L175.963 97.3818L175.963 93.0677L180.291 93.0677L180.291 97.3818Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.963 27.9141L171.635 27.9141L171.635 23.6L175.963 23.6L175.963 27.9141Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.291 32.2285L175.963 32.2285L175.963 27.9144L180.291 27.9144L180.291 32.2285Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38774 92.8804L0.0593262 92.8804L0.0593191 31.8469L4.38773 31.8469L4.38774 92.8804Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1232 101.587L8.7948 101.587L8.7948 97.2728L13.1232 97.2728L13.1232 101.587Z",
    fill: "#231F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71611 97.1948L4.3877 97.1948L4.38769 92.8807L8.71611 92.8807L8.71611 97.1948Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1232 27.7275L8.7948 27.7275L8.7948 23.4135L13.1232 23.4135L13.1232 27.7275Z",
    fill: "#231F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71611 32.041L4.3877 32.041L4.38769 27.7269L8.71611 27.7269L8.71611 32.041Z",
    fill: "#231F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8774 45.97H31.3219V41.5256H26.8774V45.97ZM31.3219 48.1922H26.8774V52.6367H31.3219V48.1922ZM22.433 54.8589V39.3033H33.5441V41.5256H35.7663V45.97H33.5441V48.1922H35.7663V52.6367H33.5441V54.8589H22.433ZM49.091 43.7478V45.97H51.3132V50.4144H42.4243V52.6367H51.3132V54.8589H40.2021V52.6367H37.9799V45.97H40.2021V43.7478H49.091ZM46.8687 45.97H42.4243V48.1922H46.8687V45.97ZM55.749 52.6367H53.5267V45.97H55.749V43.7478H66.8601V45.97H57.9712V52.6367H66.8601V54.8589H55.749V52.6367ZM80.1847 54.8589V43.7478H84.6292V54.8589H80.1847ZM69.0736 54.8589V43.7478H73.5181V48.1922H75.7403V50.4144H73.5181V52.6367H75.7403V54.8589H69.0736ZM77.9625 52.6367H75.7403V50.4144H77.9625V52.6367Z",
    fill: "#444042"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3373 79.3805H22.7817V73.1583H24.3373V79.3805ZM25.8928 80.936H24.3373V79.3805H25.8928V80.936ZM29.004 77.8249H27.4484V74.7138H29.004V77.8249ZM32.1151 80.936H30.5595V79.3805H32.1151V80.936ZM33.6706 79.3805H32.1151V73.1583H33.6706V79.3805ZM27.4484 79.3805H25.8928V77.8249H27.4484V79.3805ZM30.5595 79.3805H29.004V77.8249H30.5595V79.3805ZM36.7787 79.3805H35.2231V74.7138H36.7787V79.3805ZM41.4454 74.7138H36.7787V73.1583H41.4454V74.7138ZM43.0009 79.3805H41.4454V74.7138H43.0009V79.3805ZM41.4454 80.936H36.7787V79.3805H41.4454V80.936ZM49.2277 76.2694H47.6721V74.7138H49.2277V76.2694ZM50.7833 74.7138H49.2277V73.1583H50.7833V74.7138ZM46.1166 77.8249V80.936H44.561V73.1583H46.1166V76.2694H47.6721V77.8249H46.1166ZM58.5626 80.936H57.007V79.3805H58.5626V80.936ZM53.8959 77.8249V80.936H52.3403V70.0471H53.8959V76.2694H55.4514V77.8249H53.8959ZM57.007 76.2694H55.4514V74.7138H57.007V76.2694ZM58.5626 74.7138H57.007V73.1583H58.5626V74.7138ZM57.007 79.3805H55.4514V77.8249H57.007V79.3805ZM64.7863 76.2694H60.1196V74.7138H64.7863V76.2694ZM67.8959 80.936H66.3403V70.0471H67.8959V80.936ZM71.0131 80.936H69.4575V73.1583H71.0131V80.936ZM71.0131 71.6027H69.4575V70.0471H71.0131V71.6027ZM75.6858 73.1583H77.2414V74.7138H75.6858V80.936H74.1303V74.7138H72.5747V73.1583H74.1303V70.0471H77.2414V71.6027H75.6858V73.1583ZM85.0176 74.7138H80.351V73.1583H85.0176V74.7138ZM80.351 77.8249V79.3805H78.7954V74.7138H80.351V76.2694H85.0176V74.7138H86.5732V77.8249H80.351ZM86.5732 80.936H80.351V79.3805H86.5732V80.936ZM99.0176 79.3805V74.7138H100.573V79.3805H99.0176ZM94.351 74.7138H95.9065V76.2694H94.351V77.8249H95.9065V79.3805H94.351V80.936H92.7954V70.0471H94.351V74.7138ZM95.9065 80.936V79.3805H99.0176V80.936H95.9065ZM95.9065 74.7138V73.1583H99.0176V74.7138H95.9065ZM103.689 79.3805H102.133V74.7138H103.689V79.3805ZM108.356 76.2694H106.8V74.7138H108.356V73.1583H109.911V80.936H108.356V79.3805H106.8V77.8249H108.356V76.2694ZM106.8 80.936H103.689V79.3805H106.8V80.936ZM106.8 74.7138H103.689V73.1583H106.8V74.7138ZM113.027 80.936H111.471V70.0471H113.027V80.936ZM116.144 79.3805H114.588V74.7138H116.144V79.3805ZM120.811 76.2694H119.255V74.7138H120.811V73.1583H122.366V80.936H120.811V79.3805H119.255V77.8249H120.811V76.2694ZM119.255 80.936H116.144V79.3805H119.255V80.936ZM119.255 74.7138H116.144V73.1583H119.255V74.7138ZM125.482 76.2694V80.936H123.926V73.1583H125.482V74.7138H127.037V76.2694H125.482ZM131.704 80.936H130.148V74.7138H131.704V80.936ZM130.148 74.7138H127.037V73.1583H130.148V74.7138ZM134.82 79.3805H133.264V74.7138H134.82V79.3805ZM141.042 74.7138H134.82V73.1583H141.042V74.7138ZM141.042 80.936H134.82V79.3805H141.042V80.936ZM148.824 74.7138H144.158V73.1583H148.824V74.7138ZM144.158 77.8249V79.3805H142.602V74.7138H144.158V76.2694H148.824V74.7138H150.38V77.8249H144.158ZM150.38 80.936H144.158V79.3805H150.38V80.936Z",
    fill: "#1B1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceDesc);
export default __webpack_public_path__ + "static/media/balanceDesc.a503f84e1390dfc042683ceca308920e.svg";
export { ForwardRef as ReactComponent };